/// <reference types="facebook-pixel" />

declare global {
  interface Window {
    fbq: facebook.Pixel.Event;
  }
}

type FacebookPixelEvent = {
  name: string;
  parameters?: facebook.Pixel.ViewContentParameters;
  options?: facebook.Pixel.EventIDOptions;
};

const PIXEL_ID_1 = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
const PIXEL_ID_2 = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID_2;

export const PageView = () => {
  window.fbq('track', 'PageView');
};

export const initFacebookPixel = () => {
  if (PIXEL_ID_1) {
    window.fbq('init', PIXEL_ID_1);
  }
  if (PIXEL_ID_2) {
    window.fbq('init', PIXEL_ID_2);
  }

  PageView();
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (eventData: FacebookPixelEvent) => {
  // Logging on dev to help debugging
  if (process.env.NODE_ENV === 'development') {
    // Cleaning undefined from the object to help visualization
    Object.keys(eventData).forEach(
      (key) =>
        eventData[key as keyof FacebookPixelEvent] === undefined &&
        delete eventData[key as keyof FacebookPixelEvent],
    );
    //console.log(`Trying to send ${eventData.name} action to fbq`, eventData);
  }

  window.fbq('track', eventData.name, eventData.parameters || {}, eventData.options);

  if (process.env.NODE_ENV === 'development') {
    console.log(`Event ${eventData.name} sent to fbq (both pixels)`);
  }
};
